<template>
	<div class="index nobg" v-loading="loading">
		<HeaderInc ref="ref_header" :info="info"></HeaderInc>
		<div class="warp main_body">
			<div class="left_mune">
				<ul>
					<li @click="gohome">
						<img src="../assets/ico_3.png" />
						个人设置
					</li>
					<li class="active" @click="gowork">
						<img src="../assets/ico_4.png" />
						作品管理
					</li>
					<li @click="gocer">
						<img src="../assets/ico_7.png" />
						证书查询
					</li>
				</ul>
			</div>
			<div class="main_content">
				<h1>>作品{{work_id > 0?'编辑':'添加'}}</h1>
				<div class="main_content_g">
					<el-form ref="work_form" :model="workinfo" :rules="rules" status-icon label-width="120px"
						class="demo-ruleForm">

						<el-form-item label="组别" prop="group_id">
							<el-radio-group v-model="workinfo.group_id">
								<el-radio v-for="item in groupOptions" 
                                         :key="item.value" 
                                         :label="item.value">
                                    {{item.label}}
                                </el-radio>
							</el-radio-group>
						</el-form-item>

						<el-form-item label="赛场" prop="match_id">
							<el-select v-model="workinfo.match_id" @change="matchchange" filterable placeholder="请选赛事"
								:disabled="workinfo.id > 0">
								<el-option v-for="item in match_list" :key="item.id" :label="item.title"
									:value="item.id">
									<span style="float: left">{{ item.title }}</span>
									<span
										style="float: right;color: var(--el-text-color-secondary);font-size: 12px;">{{ match_type_options[item.type] }}</span>
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="赛道" :prop="isfmt==3?'wtype':''" v-show="isfmt==3">
							<el-select v-model="workinfo.wtype" filterable placeholder="请选赛道">
								<el-option v-for="item in wtype_option[year]" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="作品类型" prop="type">
							<el-select v-model="workinfo.type" @change="typechange" filterable placeholder="请选类型~"
								:disabled="workinfo.hexiao == 1">
								<template v-for="(item,index) in options">
									<el-option v-if="canshow(item.value)" :label="item.label"
										:value="item.value">
									</el-option>
								</template>
							</el-select>
						</el-form-item>
						<el-form-item label="作品名称" prop="title">
							<el-input v-model="workinfo.title" type="text" placeholder="请输入作品/论文的主题" autocomplete="off">
							</el-input>
						</el-form-item>
						
						<el-form-item label="第一作者">
							<el-col :span="12">
								<el-input v-model="team[0].name" maxlength="60" type="text" readonly="readonly"
									autocomplete="off">
								</el-input>
							</el-col>
							<el-col :span="12">
								<el-input v-model="team[0].phone" type="text" readonly="readonly"
									autocomplete="off">
								</el-input>
							</el-col>
						</el-form-item>
						
						<el-form-item label="第二作者">
							<el-col :span="12">
								<el-input v-model="team[1].name" maxlength="60" type="text" placeholder="请输入姓名"
									autocomplete="off">
								</el-input>
							</el-col>
							<el-col :span="12">
								<el-input v-model="team[1].phone" type="text" placeholder="请输入电话"
									autocomplete="off">
								</el-input>
							</el-col>
						</el-form-item>
						
						<el-form-item label="第三作者">
							<el-col :span="12">
								<el-input v-model="team[2].name" maxlength="60" type="text" placeholder="请输入姓名"
									autocomplete="off">
								</el-input>
							</el-col>
							<el-col :span="12">
								<el-input v-model="team[2].phone" type="text" placeholder="请输入电话"
									autocomplete="off">
								</el-input>
							</el-col>
						</el-form-item>
						
						<el-form-item label="第四作者" v-show="workinfo.type == 2">
							<el-col :span="12">
								<el-input v-model="team[3].name" maxlength="60" type="text" placeholder="请输入姓名"
									autocomplete="off">
								</el-input>
							</el-col>
							<el-col :span="12">
								<el-input v-model="team[3].phone" type="text" placeholder="请输入电话"
									autocomplete="off">
								</el-input>
							</el-col>
						</el-form-item>
						
						<el-form-item label="第五作者" v-show="workinfo.type == 2">
							<el-col :span="12">
								<el-input v-model="team[4].name" maxlength="60" type="text" placeholder="请输入姓名"
									autocomplete="off">
								</el-input>
							</el-col>
							<el-col :span="12">
								<el-input v-model="team[4].phone" type="text" placeholder="请输入电话"
									autocomplete="off">
								</el-input>
							</el-col>
						</el-form-item>
						
						
						<el-form-item label="指导老师1">
							<el-col :span="12">
								<el-input v-model="workinfo.teacher" maxlength="60" type="text" placeholder="请输入指导老师姓名"
									autocomplete="off">
								</el-input>
							</el-col>
							<el-col :span="12">
								<el-input v-model="workinfo.tphone" type="text" placeholder="请输入指导老师电话"
									autocomplete="off">
								</el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="指导老师2">
							<el-col :span="12">
								<el-input v-model="workinfo.teacher1" maxlength="60" type="text" placeholder="请输入指导老师姓名"
									autocomplete="off">
								</el-input>
							</el-col>
							<el-col :span="12">
								<el-input v-model="workinfo.tphone1" type="text" placeholder="请输入指导老师电话"
									autocomplete="off">
								</el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="作品说明" prop="profile">
							<el-input v-model="workinfo.profile" type="textarea" rows="5" placeholder="请输入作品说明">
							</el-input>
						</el-form-item>
						<el-form-item label="海报" prop="image" v-show="isfmt!=2 && workinfo.type < 3">
							<div class="up_txt">
								<span class="haibao_tishi">
									<a href="/doc/demo.zip" target="_blank">海报模板下载</a>
								</span>
							</div>
							<el-upload class="avatar-uploader" action=""
								:show-file-list="false" :before-upload="beforeAvatarUpload">
								<img v-if="workinfo.image" :src="workinfo.image" class="avatar" />
								<i v-else><span class="el-icon-plus"></span><span class="txt">海报上传</span></i>
							</el-upload>
							<div class="up_txt">
								<span>要求：将作品文件编排于单幅A3幅面、竖式、300dpi、JPG、RGB\CMYK，文件不超过10MB</span>
								<span>提示: 展示海报将用于作品评审、展出等场景，将直观影响比赛成绩哦~</span>
							</div>
						</el-form-item>

						<el-form-item label="图片" v-show="workinfo.type == 1">
							<el-upload class="upload-demo" drag action=""
								accept="image/jpg,image/png,image/jpeg,image/gif" :limit="3"
								:before-upload="beforefileUpload"
								:file-list="fileList" :on-remove="filedel" list-type="picture" multiple>
								<i class="el-icon-upload"></i>
								<div class="el-upload__text">
									拖动文件捯框内 <em>点击上传</em>
								</div>
							</el-upload>
							<div class="up_txt">
								<span>要求：单幅画面限定A3大小、300dpi、JPG、GIF、RGB\CMYK；上传不超过3张；</span>
								<span>大小: 单个文件不超过10MB</span>
							</div>
						</el-form-item>

						<el-form-item label="音频/视频" prop="videofile" v-show="workinfo.type == 2">
							<el-upload class="upload-demo" drag action="" accept="video/mp4,audio/wav" :limit="1"
								:on-remove="videodel" :before-upload="beforevideoUpload" :file-list="videoList">
								<i class="el-icon-upload"></i>
								<div class="el-upload__text">
									拖动文件捯框内 <em>点击上传</em>
								</div>
							</el-upload>
							<el-progress :percentage="jindutiao" v-show="jindutiao_show" />
							<div class="up_txt">
								<span>视频格式：编码格式H.264、mp4格式</span>
								<span>音频格式：WAV音频文件，音频采样频率不小于44.1KHz，16Bit</span>
								<span>要求：时间长度控制在5分钟以内，视频文件不超过500MB</span>
								<span class="el-color-red">交互式交互app及网页须提供动态演示视频和运行文件</span>
							</div>
						</el-form-item>
						
						<el-form-item label="运行文件" v-show="workinfo.type == 2">
							<el-upload class="upload-demo" drag action="" accept="application/zip" :limit="1"
								:on-remove="zipdel" :before-upload="beforezipUpload" :file-list="zipList">
								<i class="el-icon-upload"></i>
								<div class="el-upload__text">
									拖动文件捯框内 <em>点击上传</em>
								</div>
							</el-upload>
							<el-progress :percentage="ziptiao" v-show="ziptiao_show" />
							<div class="up_txt">
								<span>格式：zip压缩文件格式,500MB以内</span>
								<span class="el-color-red">交互式交互app及网页须提供动态演示视频和运行文件</span>
							</div>
						</el-form-item>
						
						<el-form-item label="文档" v-show="workinfo.type == 3">
							<el-upload class="upload-demo" drag action=""
								accept="application/msword,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
								:limit="3" :before-upload="beforedocUpload"
								:on-remove="docremove" :file-list="docList" multiple>
								<i class="el-icon-upload"></i>
								<div class="el-upload__text">
									拖动文件捯框内 <em>点击上传</em>
								</div>
							</el-upload>
							<div class="up_txt">
								<span>格式：doc,docx,pdf,格式</span>
								<span>要求：单文件不超过10MB</span>
							</div>
						</el-form-item>

						<el-form-item :label="hjtxt">
							<el-input v-model="workinfo.jxtxt" type="textarea" rows="5" :placeholder="hjtxtdesc">
							</el-input>
						</el-form-item>

						<el-form-item :label="hjzstxt">
							<el-upload class="upload-demo" drag action=""
								accept="image/jpg,image/png,image/jpeg" :limit="5"
								:before-upload="beforezhengshuUpload" :file-list="zhengshuList" :on-remove="zhengshudel"
								list-type="picture" multiple>
								<i class="el-icon-upload"></i>
								<div class="el-upload__text">
									拖动文件捯框内 <em>点击上传</em>
								</div>
							</el-upload>
							<div class="up_txt">
								<span>要求：单个证书小于2M,JPG格式，最多上传5个</span>
							</div>
						</el-form-item>

						<el-form-item v-show="workinfo.hexiao != '1'">
							<a class="button_1" @click="submitForm('work_form')">保存</a>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import httpUtil from '@/util/HttpRequestUtil'
	import HeaderInc from '@/components/HeaderInc.vue'
	import OSS from 'ali-oss'
	export default {
		name: 'Workadd',
		components: {
			HeaderInc
		},
		props: {},
		data() {
			return {
				loading: true,
				type: 0,
				options: [{
						label: '图片',
						value: 1
					},
					{
						label: '音视频',
						value: 2
					},
					{
						label: '论文',
						value: 3
					}
				],
				canworktype:[],
				workinfo: {},
				rules: {
					type: [{
						required: true,
						message: '请选择作品类型~',
						trigger: 'blur'
					}],
					title: [{
						required: true,
						message: '请输入作品主题',
						trigger: 'blur'
					}],
					profile: [{
						required: true,
						message: '请输入主题说明',
						trigger: 'blur'
					}],
					image: [{
						required: true,
						message: '请上传海报',
						trigger: 'blur'
					}],
					videofile:[],
					group_id: [{
						required: true,
						message: '请选择组别',
						trigger: 'blur'
					}],
					match_id: [{
						required: true,
						message: '请选择赛场',
						trigger: 'blur'
					}],
					wtype: [{
						required: true,
						message: '请选择赛道',
						trigger: 'blur'
					}]
				},
				team: [
					{'name':'','phone':''},
					{'name':'','phone':''},
					{'name':'','phone':''},
					{'name':'','phone':''},
					{'name':'','phone':''}
				],
				oldteam:'',
				fileList: [],
				videoList: [],
				zipList: [],
				docList: [],
				zhengshuList: [],
				work_id: 0,
				info: {
					token: '',
					avatar: '',
					name: ''
				},
				match_list: [],
				match_type_options: ['未知', '命题', '特邀', '非命题'],
				isfmt: 1,
				wtype_option: [],
				hjtxt: '曾获奖项',
				hjtxtdesc: '请输入作品曾获得奖项,一行一个奖项',
				hjzstxt: '获奖证书',
				jindutiao: 0,
				jindutiao_show: false,
				ziptiao: 0,
				ziptiao_show: false,
				year:2024,
				defaultGroupOptions: [
					{ label: '本科研究生组', value: 1 },
					{ label: '专科生组', value: 4 },
					{ label: '教师组', value: 2 },
					{ label: '设计师组', value: 3 },
					{ label: '青少年组', value: 5 }
				],
				groupOptions: [
					{ label: '本科研究生组', value: 1 },
					{ label: '专科生组', value: 4 },
					{ label: '教师组', value: 2 },
					{ label: '设计师组', value: 3 },
				],
				// OSS配置
				ossConfig: {
					region: 'oss-cn-shenzhen',
					accessKeyId: 'LTAI5tGZdXHkWmmE4VhdjHx8',
					accessKeySecret: 'ESvQ0dKpEA59Bj1f1q1BBCmxTjRX2S',
					bucket: 'oda20260204'
				},
				// 上传状态跟踪
				uploadingFiles: {
					poster: false,      // 海报
					images: 0,          // 图片作品（数量）
					video: false,       // 视频
					zip: false,         // 运行文件
					docs: 0,            // 文档（数量）
					certificates: 0     // 证书（数量）
				}
			}
		},
		created() {
			this.getuserdata();
			this.getfmtoption();
		},
		updated() {

		},
		activated() {
			this.work_id = this.$route.query.work_id
			this.getworkinfo()
		},
		deactivated() {
			this.work_id = 0
			this.workinfo = {}
			this.team = [{'name':'','phone':''},
					{'name':'','phone':''},
					{'name':'','phone':''},
					{'name':'','phone':''},
					{'name':'','phone':''}]
			this.oldteam = ''
			this.fileList = []
			this.videoList = []
			this.zipList = []
			this.docList = []
			this.zhengshuList = []
			// 重置上传状态
			this.uploadingFiles = {
				poster: false,
				images: 0,
				video: false,
				zip: false,
				docs: 0,
				certificates: 0
			}
		},
		methods: {
			// 检查是否有文件正在上传
			hasUploadingFiles() {
				var that = this
				if (that.uploadingFiles.poster) {
					return '海报正在上传中'
				}
				if (that.uploadingFiles.images > 0) {
					return '图片作品正在上传中'
				}
				if (that.uploadingFiles.video) {
					return '视频正在上传中'
				}
				if (that.uploadingFiles.zip) {
					return '运行文件正在上传中'
				}
				if (that.uploadingFiles.docs > 0) {
					return '文档正在上传中'
				}
				if (that.uploadingFiles.certificates > 0) {
					return '证书正在上传中'
				}
				return false
			},
			submitForm(form) {
				var that = this

				// 检查是否有文件正在上传
				const uploadingMsg = that.hasUploadingFiles()
				if (uploadingMsg) {
					that.$message.warning('请等待文件上传完成：' + uploadingMsg)
					return false
				}

				that.$refs[form].validate((valid) => {
					if (valid) {

						if (that.workinfo.type == 1 && !that.workinfo.images) {
							that.$message.error('请上传图片作品')
							return false
						}

						if (that.workinfo.type == 2 && !that.workinfo.videofile) {
							that.$message.error('请上传音频、视频作品')
							return false
						}

						if (that.workinfo.type == 3 && !that.workinfo.docfile) {
							that.$message.error('请上传论文')
							return false
						}
						
						let newteam = JSON.parse(JSON.stringify(that.team))
						
						let newteam1 = [];
						for(let i in newteam){
							if(newteam[i].phone || newteam[i].name){
								newteam1.push(newteam[i]);
							}
						}
						
						for(let i in newteam1){
							if (!(/^1[3456789]\d{9}$/.test(newteam1[i].phone))) {
								that.$message.error('创作成员手机号格式不对~')
								return false
							}
							
							if(!newteam1[i].name){
								that.$message.error('请填写创作成员姓名~')
								return false
							}
							
							if (!(/[\u4e00-\u9fa5a-zA-Z·]+$/.test(newteam1[i].name))) {
								that.$message.error('创作成员姓名只能是中英文')
								return false
							}
							
						}
						
						let phones = newteam1.map(value=>value.phone)
						let phones1 = new Set(phones);
						if(phones.length > phones1.size){
							that.$message.error('创作成员手机号重复~')
							return false
						}
						
						if(that.workinfo.teacher?.length > 0 && !(/[\u4e00-\u9fa5a-zA-Z·]+$/.test(that.workinfo?.teacher))){
							that.$message.error('指导老师姓名只能是中英文')
							return false
						}
						
						if(that.workinfo.teacher1?.length > 0 && !(/[\u4e00-\u9fa5a-zA-Z·]+$/.test(that.workinfo?.teacher1))){
							that.$message.error('指导老师姓名只能是中英文')
							return false
						}
						
						if(that.workinfo.tphone?.length > 0 && !(/^1[3456789]\d{9}$/.test(that.workinfo?.tphone))){
							that.$message.error('指导老师手机格式不对')
							return false
						}
						
						if(that.workinfo.tphone1?.length > 0 && !(/^1[3456789]\d{9}$/.test(that.workinfo?.tphone1))){
							that.$message.error('指导老师手机格式不对')
							return false
						}
						
						let data = that.workinfo
						data.ac = "worksave"
						data.token = that.info.token
						
						if (JSON.stringify(newteam1) != that.oldteam) {
							data.team = JSON.stringify(newteam1)
						}
						if(!that.loading){
							that.loading = true
							httpUtil.post('/api/', data, function(res) {
								if (res.status == 1) {
									that.$message({
										showClose: true,
										message: '操作成功,1秒收返回作品列表',
										type: 'success'
									})
									that.loading = false
									setTimeout(function() {
										that.gowork()
									}, 1000)
								} else {
									if(res.msg){
										that.$message.error(res.msg)
									}else{
										that.$message.error('网络错误')
									}
									that.loading = false
								}
							})
						}
					}
				})
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg'
				const isLt10M = file.size < 1024 * 1024 * 10

				if (!isJPG) {
					this.$message.error('请上传jpg图片格式~')
					return false
				}
				if (!isLt10M) {
					this.$message.error('海报保持10M以下~')
					return false
				}

				var that = this
				that.uploadingFiles.poster = true

				let date = new Date()
				let path = httpUtil.formatDate(date, 'yyyyMMdd')
				let filename = date.valueOf() + '_' + parseInt(Math.random() * (9999 - 1000 + 1) + 1000, 10) + '.jpg'

				var client = new OSS(that.ossConfig)

				client.put('poster/' + path + '/' + filename, file).then(function(res) {
					that.workinfo.image = 'https://oss.oda.org.cn/' + res.name
					that.uploadingFiles.poster = false
				}).catch((err) => {
					console.log(err)
					that.$message.error('海报上传失败，请重试')
					that.uploadingFiles.poster = false
				})

				return false
			},
			filedel(file, fileList) {
				var that = this
				let str = ''
				for (let i in fileList) {
					if (fileList[i].url) {
						str += fileList[i].url + '|'
					}
				}
				if (str.length > 0) {
					str = str.substring(0, str.length - 1)
				}
				that.workinfo.images = str
			},
			beforefileUpload(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/gif'
				const isLt10M = file.size < 1024 * 1024 * 10
				if (!isJPG) {
					this.$message.error('请上传jpg/gif图片格式~')
					return false
				}
				if (!isLt10M) {
					this.$message.error('单张图片在10M以下~')
					return false
				}

				var that = this
				that.uploadingFiles.images++

				let date = new Date()
				let path = httpUtil.formatDate(date, 'yyyyMMdd')
				let ext = file.type === 'image/gif' ? '.gif' : '.jpg'
				let filename = date.valueOf() + '_' + parseInt(Math.random() * (9999 - 1000 + 1) + 1000, 10) + ext

				var client = new OSS(that.ossConfig)

				client.put('images/' + path + '/' + filename, file).then(function(res) {
					let rows = {}
					rows.name = file.name
					rows.url = 'https://oss.oda.org.cn/' + res.name
					that.fileList.push(rows)

					// 更新 workinfo.images
					let str = ''
					for (let i in that.fileList) {
						str += that.fileList[i].url + '|'
					}
					str = str.substring(0, str.length - 1)
					that.workinfo.images = str

					that.uploadingFiles.images--
				}).catch((err) => {
					console.log(err)
					that.$message.error('图片上传失败，请重试')
					that.uploadingFiles.images--
				})

				return false
			},
			videodel() {
				var that = this
				that.workinfo.videofile = ''
			},
			zipdel() {
				var that = this
				that.workinfo.fujian = ''
			},
			beforevideoUpload(file) {
				const isVideo = file.type === 'video/mp4' || file.type === 'audio/wav'
				const isLt500M = file.size < 1024 * 1024 * 500

				if (!isVideo) {
					this.$message.error('请上传MP4/WAV格式~')
					return false
				}
				if (!isLt500M) {
					this.$message.error('视频保持在500M以下~')
					return false
				}

				var that = this
				that.uploadingFiles.video = true

				let ext = '.mp4'
				if(file.type === 'audio/wav'){
					ext = '.wav'
				}
				let date = new Date()
				let path = httpUtil.formatDate(date, 'yyyyMMdd')
				let filename = date.valueOf() + '_' + parseInt(Math.random() * (9999 - 1000 + 1) + 1000, 10) + ext

				var client = new OSS(that.ossConfig)

				that.jindutiao_show = true
				const progress = (p, _checkpoint) => {
					that.jindutiao = parseInt(p*100)
				}

				client.multipartUpload('video/' + path + '/' + filename, file, {
					progress,
					meta: {
						year: 2022,
						people: 'zzm'
					}
				}).then(function(res) {
					let rows = {}
					rows.name = file.name
					rows.url = 'https://oss.oda.org.cn/' + res.name
					let newarray = []
					newarray.push(rows)
					that.videoList = newarray
					that.workinfo.videofile = rows.url
					that.jindutiao = 0
					that.jindutiao_show = false
					that.uploadingFiles.video = false
				}).catch((err) => {
					console.log(err)
					that.$message.error('视频上传失败，请重试')
					that.jindutiao = 0
					that.jindutiao_show = false
					that.uploadingFiles.video = false
				})
				return false
			},
			beforezipUpload(file) {
				const isZip = file.name.split('.').pop().toLowerCase() == 'zip'
				const isLt500M = file.size < 1024 * 1024 * 500
				if (!isZip) {
					this.$message.error('请上传zip压缩包附件~')
					return false
				}
				if (!isLt500M) {
					this.$message.error('文件保持在500M以下~')
					return false
				}

				var that = this
				that.uploadingFiles.zip = true

				let date = new Date()
				let path = httpUtil.formatDate(date, 'yyyyMMdd')
				let filename = date.valueOf() + '_' + parseInt(Math.random() * (9999 - 1000 + 1) + 1000, 10) + '.zip'

				var client = new OSS(that.ossConfig)

				that.ziptiao_show = true
				const progress = (p, _checkpoint) => {
					that.ziptiao = parseInt(p*100)
				}

				client.multipartUpload('fujian/' + path + '/' + filename, file, {
					progress,
					meta: {
						year: 2021,
						people: 'zzm'
					}
				}).then(function(res) {
					let rows = {}
					rows.name = file.name
					rows.url = 'https://oss.oda.org.cn/' + res.name
					let newarray = []
					newarray.push(rows)
					that.zipList = newarray
					that.workinfo.fujian = rows.url
					that.ziptiao = 0
					that.ziptiao_show = false
					that.uploadingFiles.zip = false
				}).catch((err) => {
					console.log(err)
					that.$message.error('运行文件上传失败，请重试')
					that.ziptiao = 0
					that.ziptiao_show = false
					that.uploadingFiles.zip = false
				})
				return false
			},
			docremove(file, fileList) {
				var that = this
				let str = ''
				for (let i in fileList) {
					if (fileList[i].url) {
						str += fileList[i].url + '|'
					}
				}
				if (str.length > 0) {
					str = str.substring(0, str.length - 1)
				}
				that.workinfo.docfile = str
			},
			beforedocUpload(file) {
				const isDoc = file.type === 'application/msword' || file.type === 'application/pdf' || file.type ===
					'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
				const isLt10M = file.size < 1024 * 1024 * 10

				if (!isDoc) {
					this.$message.error('请上传doc/pdf/docx')
					return false
				}

				if (!isLt10M) {
					this.$message.error('文档保持在10M以下~')
					return false
				}

				var that = this
				that.uploadingFiles.docs++

				let date = new Date()
				let path = httpUtil.formatDate(date, 'yyyyMMdd')
				let ext = '.pdf'
				if (file.type === 'application/msword') {
					ext = '.doc'
				} else if (file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
					ext = '.docx'
				}
				let filename = date.valueOf() + '_' + parseInt(Math.random() * (9999 - 1000 + 1) + 1000, 10) + ext

				var client = new OSS(that.ossConfig)

				client.put('docs/' + path + '/' + filename, file).then(function(res) {
					let rows = {}
					rows.name = file.name
					rows.url = 'https://oss.oda.org.cn/' + res.name
					that.docList.push(rows)

					// 更新 workinfo.docfile
					let str = ''
					for (let i in that.docList) {
						str += that.docList[i].url + '|'
					}
					str = str.substring(0, str.length - 1)
					that.workinfo.docfile = str

					that.uploadingFiles.docs--
				}).catch((err) => {
					console.log(err)
					that.$message.error('文档上传失败，请重试')
					that.uploadingFiles.docs--
				})

				return false
			},
			getfmtoption(){
				var that = this
				let data = {}
				data.ac = 'getfmt'
				httpUtil.post('/api/', data, function(res) {
					that.wtype_option = res;
				})
			},
			getuserdata() {
				var that = this
				var userinfo = JSON.parse(localStorage.getItem('userinfo')) || [];
				if (!userinfo.token) {
					that.gologin()
					return false
				}
				let data = {}
				data.ac = 'getuserinfo'
				data.token = userinfo.token
				data.year = that.year
				httpUtil.post('/api/', data, function(res) {
					if (res) {
						if (res.status == 1) {
							that.info = res
							that.info.type = parseInt(res.type)
							that.loading = false
						} else {
							that.$message.error('请先完成注册~')
							that.gohome()
						}
					} else {
						that.gologin()
						return false
					}
				})
			},
			getworkinfo() {
				var that = this
				var userinfo = JSON.parse(localStorage.getItem('userinfo')) || [];
				let data = {}
				data.ac = 'getworkinfo'
				data.token = userinfo.token
				data.id = that.work_id
				httpUtil.post('/api/', data, function(res) {
					that.match_list = res.match_list
					if (that.info.type > 0) {
						that.workinfo.group_id = 2
					} else {
						that.workinfo.group_id = 1
					}
					if (res.workinfo) {
						res.workinfo.group_id = parseInt(res.workinfo.group_id)
						res.workinfo.wtype = parseInt(res.workinfo.wtype)
						res.workinfo.type = parseInt(res.workinfo.type)
						that.workinfo = res.workinfo
						
						if(res.workinfo.type == 3){
							that.rules.image = []
						}
						
						if (res.workinfo.images) {
							let flist = res.workinfo.images.split('|')
							that.fileList = that.bqfile(flist)
						}

						if (res.workinfo.docfile) {
							let flist = res.workinfo.docfile.split('|')
							that.docList = that.bqfile(flist)
						}

						if (res.workinfo.videofile) {
							let flist = res.workinfo.videofile.split('|')
							that.videoList = that.bqfile(flist)
						}
						
						if (res.workinfo.fujian) {
							let flist = res.workinfo.fujian.split('|')
							that.zipList = that.bqfile(flist)
						}
						
						if (res.workinfo.zhengshufile) {
							let flist = res.workinfo.zhengshufile.split('|')
							that.zhengshuList = that.bqfile(flist)
						}

						that.team = res.people_list
						that.oldteam = JSON.stringify(res.people_list)

						for(let i = that.team.length;i < 5;i++){
							that.team.push({'name':'','phone':''})
						}

					} else {
						that.team[0].name = that.info.name
						that.team[0].phone = that.info.phone
					}
				})
			},
			gologin() {
				var that = this
				that.$router.isBack = true
				that.$router.push({
					name: 'Index'
				})
			},
			gowork() {
				var that = this
				that.$router.isBack = true
				that.$router.push({
					name: 'Work'
				})
			},
			gohome() {
				var that = this
				that.$router.isBack = true
				that.$router.push({
					name: 'Home'
				})
			},
			matchchange(evenet) {
				var that = this
				let match = {}
				for (let i in that.match_list) {
					if (that.match_list[i].id == evenet) {
						match = that.match_list[i]
						break
					}
				}
				that.isfmt = match.type
				that.canworktype = match.work_type.split(',')
				that.workinfo.type = ''
				if (that.isfmt == 2) {
					that.rules.image = []
				} else {
					that.rules.image = [{
						required: true,
						message: '请上传海报',
						trigger: 'blur'
					}]
				}
				if(that.isfmt == 3 || that.isfmt == '3'){
					that.workinfo.wtype = 2
				}else{
					that.workinfo.wtype = 1
				}

				let allowedGroups = match.group_ids.split(',').map(Number)
				that.groupOptions = that.defaultGroupOptions.filter(item => allowedGroups.includes(item.value))

			},
			typechange(evenet) {
				var that = this
				if (evenet == 3 || that.isfmt == 2) {
					that.rules.image = []
				} else {
					that.rules.image = [{
						required: true,
						message: '请上传海报',
						trigger: 'blur'
					}]
				}
				
				if(evenet == 2){
					that.rules.videofile = [{
						required: true,
						message: '请上传音频、视频',
						trigger: 'blur'
					}]
				}else{
					that.rules.videofile = []
				}
				
				if (evenet == 3) {
					that.hjtxt = '发表情况'
					that.hjtxtdesc = '已公开发表填写发表期刊论文或会议论文情况；未公开发表填写“未发表”。'
					that.hjzstxt = '发表证明'
				} else {
					that.hjtxt = '曾获奖项'
					that.hjtxtdesc = '请输入作品曾获得奖项,一行一个奖项'
					that.hjzstxt = '获奖证书'
				}

			},
			bqfile(array) {
				if (array.length > 0) {
					let newarray = []
					for (let i in array) {
						let row = {}
						let str = array[i].split('/');
						row.url = array[i]
						row.name = str[str.length - 1]
						newarray.push(row)
					}
					return newarray
				}
			},
			zhengshudel(file, fileList) {
				var that = this
				let str = ''
				for (let i in fileList) {
					if (fileList[i].url) {
						str += fileList[i].url + '|'
					}
				}
				if (str.length > 0) {
					str = str.substring(0, str.length - 1)
				}
				that.workinfo.zhengshufile = str
			},
			beforezhengshuUpload(file) {
				const isJPG = file.type === 'image/jpeg'
				const isLt2M = file.size < 1024 * 1024 * 2
				if (!isJPG) {
					this.$message.error('请上传jpg图片格式~')
					return false
				}
				if (!isLt2M) {
					this.$message.error('单张图片在2M以下~')
					return false
				}

				var that = this
				that.uploadingFiles.certificates++

				let date = new Date()
				let path = httpUtil.formatDate(date, 'yyyyMMdd')
				let filename = date.valueOf() + '_' + parseInt(Math.random() * (9999 - 1000 + 1) + 1000, 10) + '.jpg'

				var client = new OSS(that.ossConfig)

				client.put('certificates/' + path + '/' + filename, file).then(function(res) {
					let rows = {}
					rows.name = file.name
					rows.url = 'https://oss.oda.org.cn/' + res.name
					that.zhengshuList.push(rows)

					// 更新 workinfo.zhengshufile
					let str = ''
					for (let i in that.zhengshuList) {
						str += that.zhengshuList[i].url + '|'
					}
					str = str.substring(0, str.length - 1)
					that.workinfo.zhengshufile = str

					that.uploadingFiles.certificates--
				}).catch((err) => {
					console.log(err)
					that.$message.error('证书上传失败，请重试')
					that.uploadingFiles.certificates--
				})

				return false
			},
			gocer(){
				var that = this
				that.$router.push({
					name: 'Cer'
				})
			},
			canshow(value){
				var that = this
				if(that.canworktype.indexOf(value.toString()) >= 0){
					return true
				}else{
					return false
				}
			},
		},

	}
</script>

<style>
	.teamclass .el-table .el-table__cell {
		padding: 0 !important;
	}

	.avatar-uploader {
		width: 240px;
		height: 187px;
		border: #C2C2C2 1px dashed;
		display: block;
		overflow: hidden;
		vertical-align: middle;
		text-align: center;
	}

	.avatar-uploader:hover {
		border: #E60012 1px dashed;
	}

	.avatar-uploader img {
		display: inline-block;
		max-width: 240px;
		max-height: 187px;
		vertical-align: middle;
		text-align: center;
	}

	.avatar-uploader i {
		width: 240px;
		height: 187px;
		display: block;
		overflow: hidden;
		color: #585858;
	}

	.avatar-uploader i span {
		display: block;
		font-size: 14px;
		font-style: normal;
	}

	.avatar-uploader i span.el-icon-plus {
		margin-top: 60px;
		font-size: 60px;
		color: #585858;
	}

	.el-radio__input.is-checked+.el-radio__label,
	.el-select-dropdown__item.selected,
	.el-button--text,
	.el-upload-dragger .el-upload__text em {
		color: #E60012 !important;
	}

	.el-radio__input.is-checked .el-radio__inner {
		border-color: #E60012 !important;
		background: #E60012 !important;
	}

	.el-input,
	.el-textarea {
		--el-input-focus-border: #E60012 !important;
	}

	.el-select .el-input.is-focus .el-input__inner,
	.el-select .el-input__inner:focus,
	.el-upload-dragger:hover {
		border-color: #E60012 !important;
	}

	.el-upload-list__item {
		border: #999999 1px dashed !important;
	}

	.up_txt span {
		display: block;
		font-size: 12px;
		color: #999999;
		height: 20px;
		line-height: 18px;
	}

	.up_txt span.haibao_tishi {
		width: 120px;
		border: #FF0000 2px solid;
		padding: 0 10px;
		height: 36px;
		line-height: 36px;
		text-align: center;
		font-size: 18px;
	}

	.haibao_tishi a {
		color: #FF0000;
		text-decoration: none;
	}
</style>
